import React, {
  FC,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';

import { AcceptFlowersButton } from '../AcceptFlowersButton';
import { ArticlePdf } from './article-pdf';
import { PrintModalComponent } from './types';
import Button from 'components/base/Button';
import Modal from 'components/base/Modal';
import { PdfViewrLoadSuccess } from 'components/base/PdfViewer';

import { SimpleUserRequestPermissionNames } from 'config/apiFunus/generated/data-contracts';
import { useWindow } from 'hooks/useWindow';
import './index.scss';
import { usePermissions } from 'utils/usePermissions';

export const PrintModal: FC<PrintModalComponent> = ({
  show,
  id,
  onHide,
}) => {
  const { t } = useTranslation();
  const { openInNewTab } = useWindow();
  const { hasPermission } = usePermissions();

  const [url, setUrl] = useState<string>();

  const onLoadSuccess = ({ objectUrl }: PdfViewrLoadSuccess) => {
    setUrl(objectUrl);
  };

  const openForPrint = useCallback(() => {
    if (url) {
      openInNewTab(url);
    }
  }, [url, openInNewTab]);

  useEffect(() => {
    if (!show) {
      setUrl(undefined);
    }
  }, [show]);

  return (
    <Modal
      closeOnFocusLost={false}
      footerContent={(
        <React.Fragment>
          <Button
            color="secondary"
            text={t('common.cancel')}
            onClick={() => {
              onHide();
            }}
          />
          {hasPermission(SimpleUserRequestPermissionNames.ARTICLE_SUPPLIER) && (
            <AcceptFlowersButton id={id} />
          )}
          <Button
            color="primary"
            disabled={!url}
            text={t('common.print')}
            onClick={() => {
              openForPrint();
            }}
          />
        </React.Fragment>
)}
      show={show}
      showCancel={false}
      showXButton={false}
      title={t('article.flowers.printTitle')}
      onHide={onHide}
    >
      <ArticlePdf id={id} onLoadSuccess={onLoadSuccess} />
    </Modal>
  );
};
